import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { API_URL, scroll, fmtCurrency, getValFromLS } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Notice from "../components/Notice";

import AuthnetForm from "./AuthnetForm";
import Nav from "./Nav";

const Invoice = () => {
	const [user, setUser] = useState({});
	const [order, setOrder] = useState({});
	const [names, setNames] = useState({});
	const [notice, setNotice] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const location = useLocation();

	useEffect(() => {
		const init = async () => {
			const auth = getValFromLS("dash", true)
				? JSON.parse(getValFromLS("dash", true))
				: {};
			const url = new URL(`${API_URL}/dashboardInvoiceInit`);
			const params = {
				q: auth.id ? auth.id : "",
			};
			url.search = new URLSearchParams(params);

			try {
				const response = await fetch(url, {
					method: "GET",
					cache: "no-store",
				});
				const json = await response.json();
				if (json && json.resp === 1) {
					setUser({ ...JSON.parse(getValFromLS("dash", true)) });
					setOrder({ ...json });
					handleUpdate("other", json.totals.due.replace("$", ""));
					setAlert({});
					scroll();
				} else {
					setAlert({
						type: json.resp === 2 ? "notice" : "error",
						text: json.text,
					});
				}
			} catch (error) {
				setAlert({
					type: "error",
					text: "An error has occurred.",
				});
			}
		};

		init();
	}, []);

	useEffect(() => {
		if (location.state && location.state.message) {
			setNotice({
				type: location.state.message.type,
				text: location.state.message.text,
			});
		}
	}, [location]);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg section="View Invoice" />

						<p>
							Please see below for a current snapshot of your selected
							sponsorship. The printable invoice link provides details on
							payments received to date, as well as information for submitting
							check or ACH/wire payments. If you have any questions, please
							email{" "}
							<a href="mailto:ValeroBFC@valero.com">ValeroBFC@valero.com</a>.
						</p>

						{notice.type && <Notice data={notice} />}

						<table
							className="approved"
							style={{ marginTop: "25px", marginBottom: "25px" }}
						>
							<thead>
								<tr>
									<th className="left" style={{ width: "75%" }}>
										Sponsor Level
									</th>
									<th>Amount</th>
								</tr>
							</thead>
							<tbody>
								{order.items.map((item) => {
									const subtotal = item.qty * item.amt;

									return (
										<tr key={item.id}>
											<td className="left">{item.name}</td>
											<td className="right">{fmtCurrency(subtotal / 100)}</td>
										</tr>
									);
								})}
							</tbody>
							<tfoot>
								<tr>
									<th
										className="right"
										style={{ padding: "10px", fontSize: "1.15rem" }}
									>
										TOTAL
									</th>
									<th
										className="right"
										style={{
											padding: "12.5px 7.5px 12.5px 10px",
											fontSize: "1.15rem",
										}}
									>
										{order.totals.total}
									</th>
								</tr>
								<tr>
									<td className="right" style={{ paddingRight: "10px" }}>
										Payments Received
									</td>
									<td className="right">({order.totals.paid})</td>
								</tr>
								<tr>
									<td className="right" style={{ paddingRight: "10px" }}>
										Amount Due
									</td>
									<td className="right">{order.totals.due}</td>
								</tr>
							</tfoot>
						</table>

						<div className="homebutton">
							<a
								href={`https://valerotexasopen.com/benefit-for-children/invoiceprint/?${user.id}`}
								target="_blank"
								rel="noopener noreferrer"
							>
								<i className="fa fa-print" /> &nbsp;Printable Invoice
								<i className="fa fa-angle-right" />
							</a>
						</div>

						<AuthnetForm order={order} other={names.other} />

						<div className="spacer"></div>
					</div>

					<div id="right-column">
						<Nav on={4} user={user} />
					</div>
				</>
			)}
		</>
	);
};

export default Invoice;
